import { useSyncExternalStore } from "react";
import { getQueueStatus, subscribeQueue, type QueueStatus } from "./captureQueue.js";

/** Abonnement à l'état de la file hors-ligne (en ligne ? combien d'envois en attente ?). */
export function useQueueStatus(): QueueStatus {
  return useSyncExternalStore(subscribeQueue, getQueueStatus);
}
